import { z } from "zod";
import { MessageNodeFieldTypeEnum } from "../../../enum/nodes.enum";

export const messageNodeButtonSchema = z.object({
  type: z.literal(MessageNodeFieldTypeEnum.LINK_BUTTON),
  buttonLabel: z.string(),
  buttonLink: z.string().url(),
});

export type MessageNodeButtonSchema = z.infer<typeof messageNodeButtonSchema>;
